// extracted by mini-css-extract-plugin
export default {"login":"Login_login__-uSLA","registerNow":"Login_registerNow__5R4JW","register":"Login_register__jJNW2","btnSubmit":"Login_btnSubmit__FQwFe"};